export const SELECT_MENU_ITEM = 'SELECT_MENU_ITEM';
export const SELECT_LANGUAGE = 'SELECT_LANGUAGE';
